import React from "react";
import useInfiniteSearch from "hooks/useInfiniteSearch";
import { fetchStatusBasedOfferings } from "../Codes.api.helpers";
import { reorderListingsBasedOnStatus } from "../../../../features/Listings/utils/reorderListingsBasedOnStatus";
import { offeringStatusToShow } from "../Codes.config";

const statusString = offeringStatusToShow.join(",");

export const useFetchCustomCodeOfferings = ({
  fetch,
  initialData = {},
  metadataKey,
  listingType,
} = {}) => {
  const { eud_pages_mapping: eudPagesMapping = [], metadata = {} } =
    initialData;

  const pagesToFilter = metadata[metadataKey] || [];

  const filteredEudPagesMapping = eudPagesMapping.filter((page) =>
    pagesToFilter.includes(page?.uuid)
  );

  const {
    data: offeringOptions,
    loading,
    setLoading,
    setError,
    setHasMore,
    pageNumber,
    setData,
    lastElementRef,
  } = useInfiniteSearch();

  React.useEffect(() => {
    if (!fetch) return;
    setLoading(true);
    setError(false);

    fetchStatusBasedOfferings({
      pageNumber,
      status: statusString,
      payload: { type: JSON.stringify(listingType) },
    })
      .then(({ listings, total_pages }) => {
        setHasMore(total_pages > pageNumber);
        const listData = listings.map((item) => ({
          ...item,
          label: item.title,
          value: item.uuid,
        }));

        const selectedBrandedPages = filteredEudPagesMapping.map((data) => ({
          uuid: data?.uuid,
          label: data?.title,
          value: data?.uuid,
          title: data?.title,
          status: data?.status,
          currency: data?.currency,
          type: data?.type,
          price_per_head: data?.price_per_head,
          price_international: data?.price_international,
        }));

        if (pageNumber === 1) {
          // Only Appending Selected Data on load pre selected
          const mergedUnique = Array.from(
            new Map(
              [...selectedBrandedPages, ...listData].map((item) => [
                item.value,
                item,
              ])
            ).values()
          );
          setData(
            reorderListingsBasedOnStatus(mergedUnique, offeringStatusToShow)
          );
        } else {
          setData((prev) => {
            const merged = [...prev, ...listData];
            const data = Array.from(
              new Map(merged.map((item) => [item.value, item])).values()
            );
            return reorderListingsBasedOnStatus(data, offeringStatusToShow);
          });
        }
      })
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  }, [pageNumber, setData, setError, setHasMore, setLoading, fetch]);

  return {
    loading,
    offeringOptions,
    lastElementRef,
  };
};
